import * as React from "react";
import "./ModalButton.styl";

export default class ModalButton extends React.Component<{
    onClick: () => void;
    color?: string;
}> {

    public render(): React.ReactNode {
        return (
            <div className="Discussion-ModalButton-Root" data-color={this.props.color} onClick={(event) => {
                this.props.onClick();
                event.stopPropagation();
            }}>
                {this.props.children}
            </div>
        );
    }

}